import(/* webpackMode: "eager" */ "/tmp/8de65608d263eb6/app/[locale]/error.tsx");
